<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[adjustments$]"></ef-loading-container>
<ef-manual-adjustment-presenter
  [adjustments] = 'adjustments$ | async'
  [tasks] = 'tasks$ | async'
  [contracts] = 'contracts$ | async'
  [contractsSelectItem]="contractsSelectItem$ | async"
  [txntypes] = 'txntypes$ | async'
  [userGroups] = 'userGroups$ | async'
  [directreports] = 'directreports$ | async'
  [serviceitems] = 'serviceitems$ | async'
  [payrollitems] = 'payrollitems$ | async'
  [seitems] = 'items$ | async'
  [process] = 'process$ | async'
  [userInfo] = 'userInfo$ | async'
  [companysettings] = 'companysettings$ | async'
  (SaveAdjustment)="onSaveAdjustment($event)"
  (LoadAdjustments)="onLoadAdjustments($event)"
  (AddAdjustments)="onAddAdjustments($event)"
  (DeleteAdjustment)="onDeleteAdjustment($event)"
  [selectedError]="selectedErrorWithStatus$ | async"
  (ShowError)="this.ShowError.next($event)">

</ef-manual-adjustment-presenter>
